
var Model = require("../types/Model.js");

module.exports = Model({
	name: "loading",
	init: init,
	triggers: triggers,
	handle_counter_change: handle_counter_change
});

function init() {
	this._counter = 0;
	this.push(false);
}

function triggers() {
	return {
		"start": start_loading,
		"finish": finish_loading,
	};
}

function start_loading() {
	this._counter += 1;
	this.handle_counter_change();
}

function finish_loading() {
	this._counter -= 1;
	this.handle_counter_change();
}

function handle_counter_change() {
	if (this._counter < 0)
		this._counter = 0;
	if (this._counter === 0 && this.data === true)
		this.push(false);
	if (this._counter > 0 && this.data === false)
		this.push(true);
}
